import { render, staticRenderFns } from "./PersonalExpenseTracker.vue?vue&type=template&id=5e20922f&scoped=true"
import script from "./PersonalExpenseTracker.vue?vue&type=script&lang=ts"
export * from "./PersonalExpenseTracker.vue?vue&type=script&lang=ts"
import style0 from "./PersonalExpenseTracker.vue?vue&type=style&index=0&id=5e20922f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e20922f",
  null
  
)

export default component.exports